import React from "react";
import "./EdenSpeakerIdentity.css";
// Approved assets only, shipped unmodified: Eden's portrait (the Eden Entry
// avatar) and the Cphere brain mark (the back button and brand footer).
import edenPortrait from "../assets/profilesettings.jpg";
import cphereBrainMark from "../assets/back-icon.gif";

// Who said each line of the Eden conversation.
// PARITY: this file must stay byte-identical between client (Cortex OS) and
// superadmin (Quantum OS).
//
// Eden's lines carry Eden's portrait; the signed-in person's lines carry the
// brain mark. The images are decorative: the "Eden:" / "You:" label beside
// them is what names the speaker, for sighted readers and screen readers
// alike.

export function EdenSpeakerAvatar({ speaker, working = false }) {
  const isEden = speaker === "eden";
  return (
    <img
      className={`eden-speaker-avatar eden-speaker-avatar--${isEden ? "eden" : "you"}${working ? " eden-speaker-avatar--working" : ""}`}
      src={isEden ? edenPortrait : cphereBrainMark}
      alt=""
      aria-hidden="true"
      draggable="false"
      decoding="async"
    />
  );
}

// The one working indicator: shown in Eden's reply slot only while a request
// Eden is answering has been sent and its reply has not arrived. It adds no
// timers or progress of its own; the visual is aria-hidden and the status is
// announced once by EdenActivityAnnouncer.
export function EdenThinkingLine({ className = "" }) {
  return (
    <div className={`eden-speaker-line eden-thinking-line ${className}`.trim()} aria-hidden="true">
      <EdenSpeakerAvatar speaker="eden" working />
      <strong>Eden:</strong> <span className="eden-thinking-label">thinking…</span>
    </div>
  );
}

// Polite live region. Keep it mounted: screen readers announce changes to an
// existing region, and an unchanged announcement is not spoken again.
export function EdenActivityAnnouncer({ announcement }) {
  return (
    <div className="eden-activity-announcer" role="status" aria-live="polite" aria-atomic="true">
      {announcement || ""}
    </div>
  );
}

export default EdenSpeakerAvatar;
